// One-shot location. Resolves {lat, lon, acc} or rejects with a sentence to show.

let last = null

export function locate({ fresh = false } = {}) {
  if (!fresh && last && Date.now() - last.t < 60_000) return Promise.resolve(last)
  return new Promise((resolve, reject) => {
    if (!('geolocation' in navigator)) return reject(new Error("This browser can't share your location. Search for a place instead."))
    navigator.geolocation.getCurrentPosition(
      (p) => {
        last = { lat: p.coords.latitude, lon: p.coords.longitude, acc: p.coords.accuracy, t: Date.now() }
        resolve(last)
      },
      (e) => reject(new Error(
        e.code === 1 ? 'Location is off for this site. Turn it on in your browser settings, or search for a place.'
          : e.code === 3 ? "Couldn't get a fix on your location in time. Try again, or search for a place."
            : "Couldn't find your location. Search for a place instead.",
      )),
      { enableHighAccuracy: true, timeout: 12000, maximumAge: fresh ? 0 : 30_000 },
    )
  })
}

export const lastKnown = () => last

/** Your location only if the browser already allows it (never prompts), within `ms`. */
export async function quietly(ms = 3000, { fresh = false } = {}) {
  if (!fresh && last && Date.now() - last.t < 5 * 60_000) return last
  try {
    const p = await navigator.permissions?.query({ name: 'geolocation' })
    if (p?.state !== 'granted') return null
    return await Promise.race([locate({ fresh }), new Promise((r) => setTimeout(() => r(null), ms))])
  } catch {
    return null
  }
}
